var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.10557e-05 12C-4.13454e-05 18.6274 5.37255 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 -2.34843e-07 12 -5.24538e-07C5.37255 -8.14232e-07 -4.0766e-05 5.37259 -4.10557e-05 12Z",
    className: "purple"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25731 12C4.25731 11.3636 4.78767 10.8333 5.42405 10.8333L10.8334 10.8333L10.8334 5.42392C10.8334 4.78755 11.3638 4.25719 12.0001 4.25719C12.6365 4.25719 13.1669 4.78755 13.1669 5.42392L13.1669 10.8333L18.5762 10.8333C19.2126 10.8333 19.7429 11.3636 19.7429 12C19.7429 12.6364 19.2126 13.1667 18.5762 13.1667L13.1669 13.1667L13.1669 18.5761C13.1669 19.2124 12.6365 19.7428 12.0001 19.7428C11.3638 19.7428 10.8334 19.2124 10.8334 18.5761L10.8334 13.1667L5.42405 13.1667C4.78767 13.1667 4.25735 12.6364 4.25731 12Z",
    className: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.3d5717cbc3e1a1371b0e344e8850c494.svg";
export { ForwardRef as ReactComponent };